import { Base } from '../base-component';
import './script-image.component.scss';

export class ScriptImage extends Base {

	container: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		this.container = this.element;
		this.detect();

	}

	bindEvents() {

		window.addEventListener('resize', (event)=>{

			console.log(event);
			this.detect();

		})

	}

	detect() {

		let image = this.element.getAttribute('data-desktop');
		let width = window.screen.width;

		if(width > 768) {

			image = this.element.getAttribute('data-desktop');

		}else{

			if(width > 480){

				image = this.element.getAttribute('data-tablet');

			}else{

				image = this.element.getAttribute('data-mobile');
				
			}

		}

		this.container.style.backgroundImage = "url('"+image+"')"

	}

}


// WEBPACK FOOTER //
// ./components/script-image/script-image.component.ts